import CancelIcon from "@mui/icons-material/Cancel";
import LogoutIcon from "@mui/icons-material/Logout";
import { Button } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import MDTypography from "components/MDTypography";
// eslint-disable-next-line react/prop-types
const LogoutDialog = ({ open, onClose, onLogout }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <MDTypography>Xác nhận đăng xuất</MDTypography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Bạn có chắc chắn muốn thoát phiên làm việc hiện tại này không?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ color: "#fff" }}
          color="secondary"
          type="button"
          variant="contained"
          size="small"
          onClick={onClose}
          startIcon={<CancelIcon />}
        >
          Hủy
        </Button>
        <Button
          sx={{ color: "#fff" }}
          color="primary"
          type="button"
          variant="contained"
          size="small"
          startIcon={<LogoutIcon />}
          onClick={onLogout}
        >
          Đồng ý
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutDialog;
